import { useNavigate } from 'react-router-dom';

import Button from '@/components/Button/Button';

type NavigateButton = {
  label: string;
  path: string;
};

const navigateButtons: NavigateButton[] = [
  {
    label: '本日の利用者',
    path: '/admin/achievements/today',
  },
  {
    label: '全利用者',
    path: '/admin/achievements/all',
  },
  {
    label: '来所予約一覧',
    path: '/admin/reservations/visit',
  },
  {
    label: '送迎予約一覧',
    path: '/admin/reservations/transport',
  },
  {
    label: '夕食予約一覧',
    path: '/admin/reservations/dinner',
  },
];

export const NavigationButtons = () => {
  const navigate = useNavigate();
  return (
    <div className="mt-5 flex flex-row justify-start space-x-2">
      {navigateButtons.map((button) => (
        <Button
          key={button.path}
          size="lg"
          type="submit"
          variant="solid-fill"
          onClick={() => navigate(button.path)}
        >
          {button.label}
        </Button>
      ))}
    </div>
  );
};
